module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('h4', {
    staticClass: "info-header"
  }, [_vm._v("\n  You are viewing an older version of MSDAT.\n  "), _c('span', [_c('a', {
    staticClass: "info-header-link",
    attrs: {
      "href": "https://msdat.fmohconnect.gov.ng/dashboard/Health_Outcomes_and_Service_Coverage",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Click here to move to new version.")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs small toptab",
    staticStyle: {
      "background-color": "rgb(39, 81, 80)",
      "border": "0px"
    },
    attrs: {
      "id": "toptab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: [_vm.currentPage.includes('state_profile') ? _vm.activeClass : ''],
    attrs: {
      "to": "/state_profile"
    }
  }, [_vm._v("State Profiles")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: [_vm.currentPage.includes('nhmis_analysis') ? _vm.activeClass : ''],
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "data-hover": "dropdown"
    }
  }, [_vm._v("NHMIS Analysis "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu "
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://msdat.old.fmohconnect.gov.ng/covid19_health_service_uptake/index.html",
      "target": "blank"
    }
  }, [_vm._v("Health Service Uptake")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/nhmis_analysis"
    }
  }, [_vm._v("Routine NHMIS Analysis")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "http://monthly-nhmis-analysis.fmohconnect.gov.ng/",
      "target": "blank"
    }
  }, [_vm._v("NHMIS Insights")])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: [_vm.currentPage.includes('central_analytics') ? _vm.activeClass : ''],
    attrs: {
      "to": "/central_analytics"
    }
  }, [_vm._v("MSDAT Platform")])], 1)]), _vm._v(" "), _c('v-toolbar', {
    staticStyle: {
      "height": "52px",
      "margin-top": "-5px padding: 5px 0",
      "border": "0px solid green",
      "box-shadow": "0 5px 5px -5px #333"
    },
    attrs: {
      "color": "green",
      "dark": "",
      "app": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive float-left pr-2",
    staticStyle: {
      "border-right": "1px solid #EEEEEE"
    },
    attrs: {
      "id": "logo",
      "src": "static/img/fmoh_logo.png",
      "width": "150px",
      "alt": "Logo"
    },
    on: {
      "click": function($event) {
        _vm.goto('http://health.gov.ng')
      }
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "nudge-width": 90
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [(this.$route.path === '/state_profile') ? _c('p', {
    staticClass: "navheader float-left pl-1 ml-2"
  }, [_vm._v("MSDAT State Health Profiles")]) : _c('p', {
    staticClass: "navheader float-left pl-1 ml-2 ",
    attrs: {
      "id": "name-title"
    }
  }, [_vm._v("Multi-Source Data Analytics & Triangulation (MSDAT) Platform")])])], 1), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: " float-right"
  }, [_c('div', {
    staticClass: "car-nav"
  }, [_c('span', {
    staticClass: "covid-menu",
    staticStyle: {
      "font-size": "13px",
      "text-align": "right"
    }
  }, [_c('a', {
    staticClass: "covid-button",
    staticStyle: {
      "margin-right": "25px",
      "text-decoration": "none",
      "border": "1px solid white",
      "padding": "9px 10px"
    },
    attrs: {
      "id": "covid-button",
      "href": "https://msdat.fmohconnect.gov.ng/covid19_health_service_uptake/index.html"
    }
  }, [_vm._v("Health Service Uptake")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "margin-right": "25px",
      "text-decoration": "none",
      "color": "white"
    },
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "margin-right": "25px",
      "text-decoration": "none",
      "color": "white"
    },
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("Help and FAQs")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMSDATPage),
      expression: "isMSDATPage"
    }],
    staticClass: "sections-button"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMSDATPage),
      expression: "isMSDATPage"
    }],
    staticClass: "material-button-raised tour-guide ",
    attrs: {
      "data-step": "1",
      "data-intro": "<b>Jump To Section</b><p>You can jump to any section of the platform by selecting the desired section from the drop-down menu</p>",
      "id": "dropdown-button"
    },
    on: {
      "click": function($event) {
        _vm.showNavigation()
      }
    }
  }, [_vm._v("Sections  "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-div"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavigationBool),
      expression: "showNavigationBool"
    }],
    staticClass: "navigation-dropdown",
    attrs: {
      "id": "navigation-dropdown "
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.goToZonalChart('zonalChart')
      }
    }
  }, [_vm._v("Zonal Section")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goToZonalChart('compare-section')
      }
    }
  }, [_vm._v("Multi-Source Indicator Comparison Section")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goToZonalChart('datasets')
      }
    }
  }, [_vm._v("Multi-Dataset Comparison Section")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:Userback.open();"
    }
  }, [_vm._v("\n                  Feedback\n                  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "car-icons-container-sm",
    on: {
      "mouseleave": _vm.offMoreMenu
    }
  }, [_c('span', {
    staticClass: "more-menu",
    on: {
      "click": _vm.showMoreMenu
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Site Options'),
      expression: "'Site Options'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "white--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-div",
    on: {
      "mouseleave": _vm.offMoreMenu
    }
  }, [(_vm.showMoreMenuBool === true) ? _c('div', {
    staticClass: "navigation-dropdown navigation-more-menu",
    attrs: {
      "id": "navigation-more-menu"
    }
  }, [_c('ul', {
    on: {
      "click": _vm.offMoreMenu
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "About"
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("About Dashboard")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.startTour()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Use a tour guide"
    }
  }, [_vm._v("slideshow")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "13px"
    }
  }, [_vm._v("Play Tour Guide")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.shareDashboardState()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Share"
    }
  }, [_vm._v("share")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "13px"
    }
  }, [_vm._v("Share")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.printPage()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Print"
    }
  }, [_vm._v("print")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "13px"
    }
  }, [_vm._v("Print ")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Fullscreen"
    }
  }, [_vm._v("fullscreen")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "13px"
    }
  }, [_vm._v("View Fullscreen")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Submit new data source"
    }
  }, [_vm._v("file_upload")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Submit new Data Source")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "updatelog"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "src": require("../static/img/icons/see-updates-icon.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("See Updates")])])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:Userback.open();"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "src": require("../static/img/icons/feedback-icon.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "14px"
    }
  }, [_vm._v("Feedback")])])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Contact"
    }
  }, [_vm._v("email")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Contact")])], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Help"
    }
  }, [_vm._v("help")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Help and FAQs")])], 1)], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/img/icons/subscribe-icon.svg"),
      "alt": "subscribe"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "19px"
    }
  }, [_vm._v("Subscribe to our newsletter")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "car-icons-container-lg"
  })])]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('main', [_c('v-content', [(_vm.$route.matched.length) ? [_c('fullscreen', {
    ref: "fullscreen",
    attrs: {
      "fullscreen": _vm.fullscreen
    },
    on: {
      "change": _vm.fullscreenChange,
      "update:fullscreen": function($event) {
        _vm.fullscreen = $event
      }
    }
  }, [_c('router-view')], 1)] : _vm._e()], 2)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-footer', {
    staticClass: "col-md-12 pa-3",
    staticStyle: {
      "width": "100%",
      "height": "35px",
      "font-size": "12px",
      "position": "fixed",
      "bottom": "0"
    },
    attrs: {
      "id": "footer",
      "color": "green",
      "app": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-sm-6 col-xs-4 "
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "white--text footer-text",
    staticStyle: {
      "line-height": "11px"
    },
    attrs: {
      "id": "footerTextLeft"
    }
  }, [_vm._v("Built with "), _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("♥")]), _vm._v(" by\n      "), _c('a', {
    staticClass: "white--text",
    attrs: {
      "href": "https://ehealth4everyone.com",
      "target": "_blank"
    }
  }, [_vm._v("eHealth4everyone")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-6 col-xs-8 white--text",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "footer-text",
    staticStyle: {
      "line-height": "15px"
    },
    attrs: {
      "id": "footerTextRight"
    }
  }, [_vm._v(_vm._s(this.$store.state.CAR.indicatorLength) + " Indicators, " + _vm._s(this.$store.state.CAR.sourceMetaData) + " Data sources. "), _c('router-link', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('See UpdateLog'),
      expression: "'See UpdateLog'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "update-log",
    attrs: {
      "to": "/updatelog"
    }
  }, [_vm._v("Last Updated: 19-Sept-2022")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600d74be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 788
// module chunks = 13